/**
 * Reorders rows to match a drag that has not been persisted yet.
 *
 * Rows the drag did not name keep their server position, appended after the
 * named ones — a refetch landing mid-drag can add a row the local order has
 * never seen, and dropping it would make it vanish.
 */
export const applyLocalOrder = <T extends { id: string }>(
  rows: T[],
  order: string[] | undefined
): T[] => {
  if (!order) {
    return rows
  }
  // Annotated as a tuple: TypeScript otherwise infers `(string | T)[][]` from
  // the array literal and the Map constructor rejects it.
  const byId = new Map(rows.map((row): [string, T] => [row.id, row]))
  const named = new Set(order)
  return [
    ...order.map((id) => byId.get(id)).filter((row): row is T => Boolean(row)),
    ...rows.filter((row) => !named.has(row.id)),
  ]
}
